import { Cake } from "lucide-react";
import { loadImg, iconImg, text, drawBackground, drawAvatar, drawBrand, drawCta, codeFrom } from "@/lib/badgeImage";

const LAYOUTS = {
  story: { W: 1080, H: 1920, logoY: 150, cakeY: 430, cakeR: 150, labelY: 690, titleY: 800, nameY: 900, countY: 1010, namesY: 1090, lineH: 56, lines: 7, cardY: 1560, cardH: 250 },
  square: { W: 1080, H: 1080, logoY: 90, cakeY: 250, cakeR: 95, labelY: 420, titleY: 500, nameY: 570, countY: 640, namesY: 700, lineH: 46, lines: 3, cardY: 880, cardH: 160 },
};

const wrapNames = (ctx, names, maxW, maxLines, font) => {
  ctx.font = font;
  const lines = [];
  let cur = "", used = 0;
  for (const n of names) {
    const next = cur ? `${cur} · ${n}` : n;
    if (ctx.measureText(next).width <= maxW) { cur = next; used++; continue; }
    if (lines.length + 1 >= maxLines) break;
    lines.push(cur); cur = n; used++;
  }
  if (cur) lines.push(cur);
  const rest = names.length - used;
  return { lines, rest };
};

export async function renderBirthdayImage({ user, wishes, link, format }) {
  await document.fonts?.ready;
  const base = LAYOUTS[format];
  const size = format === "story" ? 38 : 30;
  const font = `600 ${size}px "Plus Jakarta Sans", sans-serif`;
  const probe = document.createElement("canvas").getContext("2d");
  const { lines, rest } = wrapNames(probe, wishes.map((w) => w.name), base.W - 180, base.lines, font);
  const all = rest > 0 ? [...lines, `und ${rest} weitere`] : lines;
  const dy = format === "story" ? ((base.lines + 1 - all.length) * base.lineH) / 2 + 60 : ((base.lines + 1 - all.length) * base.lineH) / 2;
  const L = { ...base, ...Object.fromEntries(["cakeY", "labelY", "titleY", "nameY", "countY", "namesY"].map((k) => [k, base[k] + dy])) };
  const { W, H } = L;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  const [cake, avatar] = await Promise.all([iconImg(Cake, "#E11D48"), loadImg(user.picture, true)]);
  drawBackground(ctx, W, H);

  await drawBrand(ctx, W, L.logoY, format === "story" ? 1.2 : 1);
  [1.45, 1.22].forEach((m, i) => { ctx.beginPath(); ctx.arc(W / 2, L.cakeY, L.cakeR * m, 0, Math.PI * 2); ctx.fillStyle = `rgba(255,255,255,${i ? 0.2 : 0.1})`; ctx.fill(); });

  drawAvatar(ctx, avatar, user.name, W / 2, L.cakeY, L.cakeR);
  const b = L.cakeR * 0.75;
  ctx.beginPath(); ctx.arc(W / 2 + L.cakeR * 0.75, L.cakeY + L.cakeR * 0.7, b / 2 + 10, 0, Math.PI * 2); ctx.fillStyle = "#fff"; ctx.fill();
  if (cake) ctx.drawImage(cake, W / 2 + L.cakeR * 0.75 - b * 0.35, L.cakeY + L.cakeR * 0.7 - b * 0.35, b * 0.7, b * 0.7);

  text(ctx, "HEUTE IST MEIN GEBURTSTAG", W / 2, L.labelY, { size: 34, font: "Plus Jakarta Sans", color: "rgba(255,255,255,0.85)" });
  text(ctx, "Happy Birthday!", W / 2, L.titleY, { size: format === "story" ? 120 : 88, weight: 800, maxW: W - 120, fit: true });
  text(ctx, user.name, W / 2, L.nameY, { size: format === "story" ? 60 : 48, maxW: W - 200 });

  const n = wishes.length;
  text(ctx, n ? `Danke für ${n} ${n === 1 ? "Glückwunsch" : "Glückwünsche"} 💖` : "Danke an die ganze Community 💖", W / 2, L.countY, { size: format === "story" ? 46 : 38, weight: 700, font: "Plus Jakarta Sans" });

  all.forEach((l, i) => text(ctx, l, W / 2, L.namesY + i * L.lineH, { size, weight: 600, font: "Plus Jakarta Sans", color: "rgba(255,255,255,0.92)", maxW: W - 160 }));

  await drawCta(ctx, W, L.cardY, L.cardH, { code: codeFrom(link), title: "Feier mit & sammle Punkte für Geschenke" });

  return new Promise((resolve) => c.toBlob((bl) => resolve(bl), "image/png"));
}
